import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {Col} from 'reactstrap';
import ReactTableBase from '../../../../../shared/components/table/ReactTableBase';
import ReactTableActions from './NoteListActions';

const reorder = (rows, startIndex, endIndex) => {
  const result = Array.from(rows);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const DataReactTable = ({ title, reactTableData, Callback, printClinicNotes }) => {
  const [rows, setData] = useState(reactTableData.tableRowsData);
  const isEditable = false;
  const isResizable = false;
  const isSortable = false;
  const withDragAndDrop = false;
  const withPagination = true;
  const withSearchEngine = false;

  useEffect(() => {

  }, [rows]);


  const updateDraggableData = (result) => {
    const items = reorder(
      rows,
      result.source.index,
      result.destination.index,
    );
    setData(items);
  };

  const updateEditableData = (rowIndex, columnId, value) => {
    setData(old => old.map((item, index) => {
      if (index === rowIndex) {
        return {
          ...old[rowIndex],
          [columnId]: value,
        };
      }
      return item;
    }));
  };

  const tableConfig = {
    isEditable,
    isResizable,
    isSortable,
    withDragAndDrop,
    withPagination,
    withSearchEngine,
    manualPageSize: [3, 6, 9, 12, 15],
    placeholder: 'Buscar',
    useActions: true,
    actions: (data) => ReactTableActions({ data, Callback, printClinicNotes })
  };

  return (
    <Col md={12} lg={12}>
      <div className="react-table__wrapper">
        <div className="card__title">
          <h5 className="bold-text">{title}</h5>
        </div>
      </div>
      <ReactTableBase
        key={withSearchEngine || isResizable || isEditable ? 'modified' : 'common'}
        columns={reactTableData.tableHeaderData}
        data={rows}
        updateEditableData={updateEditableData}
        updateDraggableData={updateDraggableData}
        tableConfig={tableConfig}
      />
    </Col>
  );
};

DataReactTable.propTypes = {
  reactTableData: PropTypes.shape({
    tableHeaderData: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      name: PropTypes.string,
    })),
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
    defaultTableHeaderData: PropTypes.arrayOf(PropTypes.shape()),
    defaultTableRowData: PropTypes.arrayOf(PropTypes.shape()),
  }).isRequired,
};

export default DataReactTable;
